import { Link } from "react-router-dom";
import "../stylesheets/button.scss";
import { ReactNode } from "react";

// PROPS

type ButtonProps = {
	text: string;
	variant: "empty" | "filled" | "form";
	icon?: ReactNode;
	redirection: string;
};

// COMPONENT

function Button({ text, variant, icon, redirection }: ButtonProps) {
	return (
		<Link className={`button ${variant}`} to={redirection}>
			{icon}
			<span className="primary-text">{text}</span>
		</Link>
	);
}

export default Button;
